var map = {
	"./Action.png": 7781,
	"./Adventure.png": 7423,
	"./All.png": 2058,
	"./Board.png": 8275,
	"./Boys.png": 6294,
	"./Casual.png": 1512,
	"./Classic.png": 2811,
	"./Eliminate.png": 4311,
	"./Fighting.png": 2797,
	"./Girls.png": 2194,
	"./Hot.png": 7258,
	"./Ldle.png": 18,
	"./Mini.png": 4142,
	"./New.png": 2433,
	"./Parkour.png": 1041,
	"./Place.png": 8986,
	"./Popular.png": 6724,
	"./Puzzle.png": 5975,
	"./Racing.png": 961,
	"./Racinggame.png": 583,
	"./Simulated.png": 8757,
	"./Sports.png": 2122,
	"./Tower.png": 1308
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 104;